import React, { useState } from "react";
import {
  TextField,
  Button,
  CircularProgress,
  Box,
  Typography,
  Radio,
  Slider,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { setSuccess } from "../../../../Redux/AlertReducer";
import { useDispatch } from "react-redux";
import { Helper } from "../../../../tools/Helper";
import { api_Routes } from "../../../../tools/api_Routes";
import { errorToaster } from "../../../../helper/toasterConfiguration";
import { Styles } from "./styles";

export const FormEditBanner = ({ data, setData }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const fonts = ["Mockads", "Arial", "Great Vibes"];
  const colors = ["#FFFFFF", "#303030", "#ECA601"];
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [selectedFont, setSelectedFont] = useState(
    data?.customLogo && data?.customLogo?.fontFamily
  );
  const [selectedColor, setSelectedColor] = useState(
    data?.customLogo && data?.customLogo?.color
  );
  const [logoName, setLogoName] = useState(
    data?.customLogo && data?.customLogo?.logoName
  );
  const [fontSize, setFontSize] = useState(
    data?.customLogo && data?.customLogo?.fontSize?.replace("px", "")
  );

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFontChange = (font) => {
    setSelectedFont(font);
  };

  const handleColorClick = (color) => {
    setSelectedColor(color);
  };

  const handleFontSizeChange = (event, newValue) => {
    setFontSize(newValue);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const missingFields = [];

    const updatedFormData = {
      ...data,
    };

    if (!logoName || !selectedColor || !selectedFont || !fontSize) {
      missingFields.push(
        "customLogo properties (logoName, color, fontFamily, fontSize)"
      );
    }

    if (missingFields.length > 0) {
      errorToaster(
        `Please fill in all required fields: ${missingFields.join(", ")}`
      );
      setIsLoadingSubmit(false);
      return;
    }

    setIsLoadingSubmit(true);

    const formDataToSend = new FormData();

    updatedFormData.customLogo = {
      fontSize: `${fontSize}px`,
      color: selectedColor,
      fontFamily: selectedFont,
      logoName: logoName,
    };

    if (updatedFormData?.customLogo) {
      Object.keys(updatedFormData.customLogo).forEach((key) => {
        formDataToSend.append(`customLogo[${key}]`, updatedFormData.customLogo[key]);
      });
    }

    Object.keys(updatedFormData).forEach((key) => {
      if (key !== "customLogo") {
        formDataToSend.append(key, updatedFormData[key]);
      }
    });

    try {
      const { result, response, message } = await Helper.Put({
        url: api_Routes.BannersAdvertising.Edit + id,
        data: formDataToSend,
        isFormData: true,
      });

      setIsLoadingSubmit(false);
      if (response) {
        dispatch(setSuccess(true));
        navigate("/Ads-Banner");
      }
    } catch (error) {
      console.error("An error occurred during form submission:", error);
      setIsLoadingSubmit(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="grid grid-cols-1 items-center gap-4">
        <TextField
          fullWidth
          margin="normal"
          label="Title"
          name="title"
          required
          autoComplete="off"
          value={data?.title}
          onChange={handleInputChange}
          variant="outlined"
        />
      </div>
      <div className="grid grid-cols-1 items-center gap-4">
        <TextField
          fullWidth
          margin="normal"
          label="Description"
          name="description"
          required
          type="description"
          autoComplete="off"
          value={data.description}
          onChange={handleInputChange}
          variant="outlined"
        />
      </div>
      <div
        style={{
          opacity: 1,
          pointerEvents: "auto",
          cursor: "auto",
        }}
        className="logo"
      >
        <Styles>
          <div className="logo">
            <div className="main-title">Create your logo</div>
            <Box className="main-logo-container">
              <Box className="main-styles-container">
                <TextField
                  fullWidth
                  variant="outlined"
                  value={logoName}
                  onChange={(e) => setLogoName(e.target.value)}
                  placeholder="Type Your Logo Name here"
                  size="small"
                />
                <Box className="title-container">
                  <Typography>Choose a Font:</Typography>
                  <Box className="font-chooses-container">
                    {fonts.map((font) => (
                      <Box key={font} className="font-style-container">
                        <Typography
                          className="font-style"
                          sx={{
                            fontFamily: font,
                          }}
                        >
                          lorem
                        </Typography>
                        <Radio
                          checked={selectedFont === font}
                          onChange={() => handleFontChange(font)}
                          sx={{
                            color: "primary.main",
                          }}
                        />
                      </Box>
                    ))}
                  </Box>
                </Box>
                <Typography className="text-start">
                  Choose a color and font size:
                </Typography>
                <Box className="styles-picker-container">
                  <Box className="colors-container">
                    <Box sx={{ display: "flex", gap: 2 }}>
                      {colors.map((color) => (
                        <Box
                          key={color}
                          onClick={() => handleColorClick(color)}
                          className="color"
                          sx={{
                            backgroundColor: color,
                          }}
                        />
                      ))}
                    </Box>
                  </Box>
                  <Slider
                    value={fontSize}
                    onChange={handleFontSizeChange}
                    min={10}
                    max={50}
                    step={1}
                    valueLabelDisplay="auto"
                    sx={{ width: "100px" }}
                  />
                </Box>
              </Box>
              <div className="final">
                <Typography>Your Logo demo</Typography>
                <div className="final-logo-container">
                  <Typography
                    sx={{
                      fontSize: `${fontSize}px`,
                      color: selectedColor,
                      fontFamily: selectedFont,
                    }}
                    className="final-logo"
                  >
                    {logoName || "LOREM"}
                  </Typography>
                </div>
              </div>
            </Box>
          </div>
        </Styles>
      </div>
      <Button
        type="submit"
        fullWidth
        variant="contained"
        disabled={isLoadingSubmit}
        color="primary"
        sx={{
          display: isLoadingSubmit ? "flex" : "block",
          marginTop: 2,
          width: "20%",
          marginX: "auto",
          fontWeight: "bold",
          justifyContent: "center",
        }}
      >
        {isLoadingSubmit ? (
          <CircularProgress size={24} color="primary" />
        ) : (
          "Submit"
        )}
      </Button>
    </form>
  );
};
